import React from "react";
import { missionData, aboutImages } from "../../utils/constants";
import headingImg3 from "../../assets/headingImg3.svg";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";

const Mission = () => {
  return (
    <div
      id="mission"
      className=" sm:py-0 py-[1rem] text-justify flex lg:flex-row-reverse bg-[#fff3ed] lg:mt-0 mt-[3rem] flex-col items-center px-[3%] 2xl:px-[8%] pb-[1rem] sm:gap-[1rem] lg:gap-[6rem] "
    >
      <div className="lg:w-[55%] flex py-5  flex-col justify-center lg:min-h-[33rem]">
        <CustomHeading
          text={"Our "}
          margin="mt-0 sm:mt-0"
          customImg={headingImg3}
          heartHeight="60px"
          heartWidth="60px"
          spanText={"Mission"}
          smTextSize="32px"
        />

        <div className=" sm:mt-0 mt-4 flex flex-col gap-0">
          {missionData?.map((item) => (
            <div>
              <CustomContent
                marginTop="0px"
                textAlign="justify"
                fontWeight={700}
                textSize="18px"
                textColor="#636363"
                text={item?.heading}
              />
              <CustomContent
                marginTop="-2px"
                leading="21px"
                textAlign="justify"
                fontWeight={500}
                textSize="16px"
                textColor="#636363"
                text={item?.subheading}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="mx-auto lg:mx-0 lg:w-[45%] lg:pb-0 sm:pb-[2rem] lg:h-full">
        <img
          src={
            window.innerWidth > 450
              ? aboutImages.tabMissionImg
              : aboutImages.mobileMissionImg
          }
          className="rounded-lg h-[250px]  sm:h-[400px] lg:h-[380px] lg:min-w-[620px] sm:w-full w-[380px]"
          alt=""
        />
      </div>
    </div>
  );
};

export default Mission;
